<div class="{{ top }} text-center">
  <p-progressSpinner></p-progressSpinner>
  <h3>{{ text }}</h3>
</div>
